import { awsApiInstance } from '../api/aws-api';

import { ITerminalInsertUpdate, IPostTerminalResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Performs an api call to update an individual terminal
 * 
 * @param {ITerminalInsertUpdate} terminal the termimal object
 * 
 * @returns {IPostTerminalResponse} the api response | error
 */
export const awsUpdateTerminalIndividual = async ( terminal: ITerminalInsertUpdate ): Promise<IPostTerminalResponse> => {  
  try {
    const { data } = await awsApiInstance.put(`/terminal/${terminal.iuTerminalId}`, terminal);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating terminal data');
    throw(error);
  }
}